import { Injectable } from "@angular/core";
import { CrudService } from "app/shared/crud-service";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";
import { ActivatedRouteSnapshot, RouterStateSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { RegrasLimiteDespesaViagemDTO } from "../models/regras-limite-despesa-viagem.model";
import { AuthenticationService } from "app/helpers/authentication.service";
import { FiltroRelatorioDTO } from "app/shared/filtro-relatorio-despesa-viagem.mode";

@Injectable({
  providedIn: 'root'
})
export class RegrasLimiteDespesasViagensService extends CrudService<RegrasLimiteDespesaViagemDTO> implements Resolve<any> {
  
    public filtros: FiltroRelatorioDTO = new FiltroRelatorioDTO();
    constructor(protected http: HttpClient) {
        super(http, `${environment.apiUrlRDV}/v1/regra-limite-despesa-viagem`);
    }

    resolve(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {
        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getAllPaginated(this.filtros)]).then(() => {
                resolve();
            }, reject);
        });
    }

}